export function addEvent(evnt, ele, func) {
  var _window;
  var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (!evnt) {
    return;
  }
  var elem = ele || ((_window = window) === null || _window === void 0 ? void 0 : _window.document);
  if (elem.addEventListener) {
    // W3C DOM
    elem.addEventListener(evnt, func, capture);
  } else if (elem.attachEvent) {
    // IE DOM
    elem.attachEvent("on".concat(evnt), func);
  } else {
    elem[evnt] = func;
  }
}
export function removeEvent(evnt, ele, func) {
  var _window2;
  var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (!evnt) {
    return;
  }
  var elem = ele || ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.document);
  if (elem.removeEventListener) {
    // W3C DOM
    elem.removeEventListener(evnt, func, capture);
  } else if (elem.detachEvent) {
    // IE DOM
    elem.detachEvent("on".concat(evnt), func);
  } else {
    elem[evnt] = func;
  }
}
export function ownAddEventListener(evnt, ele, func) {
  var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  addEvent(evnt, ele, func, capture);
  return function () {
    removeEvent(evnt, ele, func, capture);
  };
}